import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { useCart } from 'Checkout/Hooks/useCart'
import useCheckoutParams from './useCheckoutParams'
import useRouter from './useRouter'

const useReloadWithParams = () => {
  const { editingReservationId, reservations } = useSelector(state => state.cart)
  const { fillCurrentReservationFromCart } = useCart()
  const { isAutoAssign, isRequest, slug } = useSelector(state => state.campground)
  const { isPurchaseComplete } = useSelector(state => state.payment)
  const { rate } = useSelector(state => state.search)
  const { validateSearchParams } = useCheckoutParams()
  const router = useRouter()

  const goToSearch = () => {
    const search = { rate_id: '', rig_length: '', rig_width: '' }
    router.go({ pathname: '/search', search })
  }

  useLayoutEffect(() => {
    validateSearchParams()
  }, [])

  useLayoutEffect(() => {
    if (slug && !rate)
      if (reservations.length && !editingReservationId) {
        const index = reservations.length - 1
        fillCurrentReservationFromCart(reservations[index].nanoId, { withRedirectTo: 'none' })
      } else if (isAutoAssign || isRequest || isPurchaseComplete)
        goToSearch()
  }, [slug])
}

export default useReloadWithParams
